import { DropdownItem } from '@lifechurch/react-ion';
import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

interface BeamerProps {
  title?: string;
  hasUpdates: boolean;
  handleClick: () => void;
}

const BeamerWrapper = styled(DropdownItem)`
  position: relative;
  display: flex;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
`;

const Title = styled.span`
  display: inline-block;
  color: inherit;
  padding-top: 2px;
  padding-inline-end: 8px;
`;

const New = styled.span`
  background-color: ${(props): string => props.theme.colors.action.light};
  color: ${(props): string => props.theme.colors.action.dark};
  border-radius: 2px;
  padding: 2px 8px;
  font-weight: normal;
  font-size: ${(props): string => props.theme.fontSizes[2]};
  display: inline-block;

  ${BeamerWrapper}:hover & {
    background-color: ${(props): string => props.theme.colors.action.hover};
    color: ${(props): string => props.theme.colors.action.light};
  }
`;

const BeamerUpdates: FC<BeamerProps> = ({ handleClick, hasUpdates, title }) => {
  const { t } = useTranslation('common');

  function onClick(): void {
    if (window.Beamer && typeof window.Beamer.show === 'function') {
      window.Beamer.show();
      window.Beamer.hide();
    }
    handleClick();
  }

  return (
    <BeamerWrapper href='https://app.getbeamer.com/product1375' onClick={onClick} target='_blank'>
      <Title>{title || t('Updates')}</Title>
      {hasUpdates && <New>{t('new')}</New>}
    </BeamerWrapper>
  );
};

export default BeamerUpdates;
